import { getFunctions, httpsCallable } from "firebase/functions";
import { FEEDBACK_HYDRATIONS, hydrate, isObject } from "shelving";
import { FIREBASE_APP } from "./app.js";

/**
 * Initialise functions and tell it to use the same domain as our Auth.
 * Running the function from the same domain eliminates the preflight CORS request.
 */
const FIREBASE_FUNCTIONS = getFunctions(FIREBASE_APP, "us-east4");

/** Call a named Cloud Function and return the (rehydrated) result. */
export async function callFunction<I = unknown, O = unknown>(name: string, payload: I): Promise<O> {
	try {
		console.debug(`⋯ CALL`, name, payload); // eslint-disable-line no-console
		const result = await httpsCallable<I, O>(FIREBASE_FUNCTIONS, name)(payload);
		console.debug(`↩ CALL`, name, result.data); // eslint-disable-line no-console
		return result.data;
	} catch (thrown) {
		console.error(`✘ CALL`, name, thrown); // eslint-disable-line no-console
		// Rehydrate any Cloud Function error with `details.feedback` into a Shelving `Feedback` instance.
		throw isObject(thrown) && isObject(thrown.details) && isObject(thrown.details.feedback) ? hydrate(thrown.details.feedback, FEEDBACK_HYDRATIONS) : thrown;
	}
}
